<script setup>
import { trans } from '@elements/translation';
import { EVENT_SLIDERS } from '../../general/event-constants';

const emit = defineEmits([ 'openModal' ]);

const emitClick = () => {
  emit('openModal', {
    title: trans('gestion.invoices.slider.credit_note'),
    name: EVENT_SLIDERS.CREATE_CREDIT_NOTE,
  });
};
</script>

<template>
  <li @click="emitClick">
    <span>{{ trans('gestion.invoices.create_credit_note') }}</span>
  </li>
</template>
